import { useEffect, useState } from "react"

export const useCyclingText = (delay = 2000, strings: string[]) => {
    if (strings.length < 2) throw "useCyclingText requires at least 2 strings."
    const [index, setIndex] = useState(0)
    const [isTransitioning, setIsTransitioning] = useState(false)

    useEffect(() => {
        setIndex(0)

        const interval = setInterval(() => {
            setIsTransitioning(false)

            setTimeout(() => {
                setIndex((prev) => (prev + 1) % strings.length)
                setIsTransitioning(true)
            }, 300)
        }, delay)

        return () => {
            clearInterval(interval)
        }
    }, [strings, delay])

    return [strings[index - 1] || strings[strings.length - 1], strings[index], isTransitioning]
}
